<template>
    <SearchObject
        :additional-params="{ ordering: 'name', ...additionalParams }"
        :autofocus="autofocus"
        :base-url="baseUrl"
        :disabled="disabled"
        :requited="required"
        :hide-details="hideDetails"
        :item-text="itemText"
        :label="label || $translate('select_organization')"
        :readonly="readonly"
        :required="required"
        :value="value"
        @input="$emit('input', $event)"
        :error-messages="errorMessages"
            ref="search"
        :dense="dense"
        :clearable="clearable"
    >
        <template slot="item" slot-scope="{ item }">
            <div class="nowrap" v-if="item">
                <b> {{ item.entity_data?.name }}</b>
                <span class="text-caption">
                    ({{ item.first_name }} {{ item.last_name }})
                </span>
            </div>
        </template>
    </SearchObject>
</template>

<script>
import GlobalMixins from "@/mixins/global";

export default {
    mixins: [GlobalMixins],
    name: "SearchProvider",
    props: {
        // The base URL to fetch items from.
        baseUrl: {
            type: String,
            default: "/api/organizations/",
        },
        // Additional GET parameters to include in the API request.
        additionalParams: {
            type: Object,
            default: () => ({}),
        },
        // Whether the component is disabled.
        disabled: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: true,
        },
        // v-model binding (selected item ID).
        value: {
            type: [String, Number],
            default: null,
        },
        // Label for the autocomplete.
        label: {
            type: String,
            default: "",
        },
        // Optional limit per request.
        limit: {
            type: Number,
            default: 20,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        hideDetails: {
            type: [Boolean, String],
            default: false,
        },
        dense: {
            type: Boolean,
            default: false,
        },
        errorMessages: {
            type: [String, Array],
            default: null,
        },
    },
    methods: {
        itemText(item) {
            if (!item || !item.entity_data) {
                return "";
            }
            return `${item.entity_data.name} (${item.first_name} ${item.last_name})`;
        },
        focus() {
            this.$refs.search.focus();
        },
    },
    i18n: {
        messages: {
            en: {
                select_organization: "Change organization",
            },
            fr: {
                select_organization: "Changer d'organisation",
            },
        },
    },
};
</script>
